import { isMobileDevice } from '@modules/common/utils/isMobileDevice';
import { Backdrop, Paper, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import { SmallScreen } from 'common/Icons/Icons';
import useHidePageScroll from 'v2/core/hooks/useHidePageScroll';

const DEFAULT_ERROR_MESSAGE = {
  title: 'Small browser window',
  subtitle: 'Enterpret works best on a larger screen size.',
};

export const SmallScreenWarningPopup = () => {
  const isScreenSmall = useMediaQuery('(max-width:900px)');
  const isMobile = isMobileDevice();
  const shouldRenderPopup = isScreenSmall && !isMobile;

  useHidePageScroll(shouldRenderPopup);

  if (!shouldRenderPopup) {
    return null;
  }

  return (
    <Backdrop
      open
      sx={{
        zIndex: 9999,
        paddingX: 2,
        backgroundColor: 'background.default',
        width: '100vw',
        height: '100vh',
      }}
    >
      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          padding: 3,
          maxWidth: 600,
          borderRadius: 3,
        }}
        variant="outlined"
      >
        <SmallScreen />
        <Typography textAlign="center" variant="h6">
          {DEFAULT_ERROR_MESSAGE.title}
        </Typography>
        <Typography textAlign="center" variant="body1">
          {DEFAULT_ERROR_MESSAGE.subtitle}
        </Typography>
      </Paper>
    </Backdrop>
  );
};
